import { closeAllForms } from '../utils/closeallforms';
import { showLoadingSpinner } from '../utils/spinner';
import { updateReferrerFields } from '../utils/updatereferrerfields';
import { validateStep } from '../utils/validatestep';
import Choices from 'choices.js';
import { getCSRFToken } from '../utils/getCSRFToken';

export default function registerProductForm() {
  // ADD NEW PRODUCT
  window.Alpine.store('productForm', {
    isOpen: false,
    calendarId: null,
    currentStep: 1,
    selectedProductType: null,
    isCreatingRates: false,
    // Properties for Choices.js
    choicesInstance: null,
    soldAsOptions: [],
    selectedRateSetOptions: [],
    // Create new rateset modal
    showAddRateModal: false,

    openForm(calendarId) {
      closeAllForms();

      // Activate backdrop
      document.getElementById('backdrop').style.display = 'block';
      console.log('Fetching product form for calendar ID:', calendarId);
      this.calendarId = calendarId;

      // Check if the form is already rendered
      const formContainer = document.getElementById(
        'open-product-form-container',
      );
      const addProductForm = document.getElementById('addProductForm');

      if (addProductForm) {
        // Form is already rendered, just open it
        addProductForm.classList.add('open');
        updateReferrerFields();
        return; // Exit the function early
      }

      // Fetch the product form from the server
      fetch(`/calendar/open-product-form/${calendarId}/`, {
        method: 'GET',
        headers: {
          'X-CSRFToken': getCSRFToken(),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          // Update the form container with the fetched HTML
          formContainer.innerHTML = data.product_form_html;

          // Add the rateset modal HTML to the DOM
          const ratesetModalContainer = document.getElementById(
            'rateset-modal-container',
          );
          ratesetModalContainer.innerHTML = data.rateset_modal_html;

          // Now open the form after a slight delay
          const addProductForm = document.getElementById('addProductForm');
          if (addProductForm) {
            setTimeout(() => {
              addProductForm.classList.add('open');
              updateReferrerFields();
            }, 100);
          } else {
            console.error(
              'Error: addProductForm element not found in the DOM.',
            );
          }
        })
        .catch((error) => {
          console.error('Error loading product form:', error);
        });
    },
    closeForm() {
      closeAllForms();
      // Deactivate backdrop
      document.getElementById('backdrop').style.display = 'none';
    },
    goToStep(step) {
      if (step > this.currentStep) {
        const stepElement = document.querySelector(`.step${this.currentStep}`);
        // Move forward if validation passed
        if (validateStep(stepElement, this.currentStep)) {
          this.currentStep = step;
        }
      } else {
        // If moving backward, no need to validate
        this.currentStep = step;
      }
    },
    // Toggle the visibility of the add rate modal
    toggleAddRateModal() {
      console.log('toggleAddRateModal clicked!!');
      this.showAddRateModal = !this.showAddRateModal;
      console.log('showAddRateModal:', this.showAddRateModal);
    },
    setProductType(type) {
      this.selectedProductType = type;

      // Fetch the rate set dropdown based on the selected product type
      const calendarId = this.calendarId;
      const url = `/products/add_rate_set/${calendarId}/${type}/`;

      fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRFToken': getCSRFToken(), // Ensure you have CSRF token handling
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text(); // Assuming the server returns HTML
        })
        .then((html) => {
          // Update the rate set dropdown in the DOM
          const rateSetDropdown = document.getElementById('rate_set_dropdown');
          if (rateSetDropdown) {
            rateSetDropdown.innerHTML = html; // Insert the new dropdown HTML
          } else {
            console.error('Rate set dropdown element not found');
          }
        })
        .catch((error) => {
          console.error('Error fetching rate set dropdown:', error);
        });
    },
    // Initialize Choices.js
    initChoices(selectElement) {
      this.choicesInstance = new Choices(selectElement, {
        removeItemButton: true,
        allowHTML: true, // Explicitly allowing HTML content
        placeholder: true, // Enable placeholder
        placeholderValue: 'Click to view existing Listings',
      });
      // Attach a change event listener directly to the Choices.js instance
      this.choicesInstance.passedElement.element.addEventListener(
        'change',
        () => {
          this.handleRateSetSelection();
        },
      );
    },
    // Update options from Backend view (add_rate_set) JSON data
    updateRateSetOptions(jsonData, selectedOptions = '[]') {
      console.log('jsonData:', jsonData);
      this.soldAsOptions = JSON.parse(jsonData);
      // Check if selectedOptions is a valid JSON string and parse it
      if (selectedOptions && selectedOptions !== '[]') {
        this.selectedRateSetOptions = JSON.parse(selectedOptions);
      } else {
        this.selectedRateSetOptions = [];
      }

      this.refreshChoices();
      // Manually call handleRateSetSelection to update the state based on current selections
      this.handleRateSetSelection();
    },
    // Update the Choices.js options
    refreshChoices() {
      if (this.choicesInstance) {
        this.choicesInstance.setChoices(
          this.soldAsOptions,
          'value',
          'label',
          false,
        );
        // Retain previously selected options
        if (
          this.selectedRateSetOptions &&
          this.selectedRateSetOptions.length > 0
        ) {
          this.choicesInstance.setValue(this.selectedRateSetOptions);
        }
      }
    },
    // Handle RateSet selection change
    handleRateSetSelection() {
      if (this.choicesInstance) {
        // Retrieve the selected items from the Choices instance
        const selectedItems = this.choicesInstance.getValue();
        // Map the selected items to their values
        this.selectedRateSetOptions = selectedItems.map((item) => item.value);
        // Update stored selected id's
        // Construct the ID of the input we want to update based on the product type
        const inputId =
          this.selectedProductType === 'Accommodation'
            ? 'selected_ids_stored_accommodation'
            : 'selected_ids_stored_tour';
        // Get the correct input element by its ID
        console.log('inputId:', inputId);
        const storedInput = document.getElementById(inputId);
        console.log('storedInput:', storedInput);
        if (storedInput) {
          storedInput.value = this.selectedRateSetOptions.join(',');
        }
        console.log('selectedRateSetOptions:', this.selectedRateSetOptions);
      }
    },
    submitRateForm(form) {
      const calendarId = form.dataset.calendarId;
      const productType = this.selectedProductType;
      const url = `/products/add_rate_set/${calendarId}/${productType}/`;

      // Get the form data
      const formData = new FormData(form);

      // Check product type-specific required fields
      if (productType === 'Accommodation') {
        const accommodationType = formData.get('accommodation_type');
        if (!accommodationType || accommodationType.trim() === '') {
          alert('Please enter a Unit Type');
          return;
        }
      } else if (productType === 'Tour') {
        const tourType = formData.get('tour_type');
        if (!tourType || tourType.trim() === '') {
          alert('Please enter a Unit Type');
          return;
        }
      }

      // Check if we have at least one complete interval
      let hasCompleteInterval = false;
      let intervalCount = 0;
      let incompleteIntervals = [];

      // Collect all interval indices from the form data
      const intervalIndices = new Set();
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('intervals[') && key.includes('][')) {
          const match = key.match(/intervals\[(\d+)\]/);
          if (match && match[1]) {
            intervalIndices.add(match[1]);
          }
        }
      }

      // Check each interval for completeness
      intervalIndices.forEach((index) => {
        intervalCount++;
        const startDate = formData.get(`intervals[${index}][startDate]`);
        const endDate = formData.get(`intervals[${index}][endDate]`);

        // Check for price - either direct price or people-based prices
        let hasPrice = false;
        const price = formData.get(`intervals[${index}][price]`);

        if (price && parseFloat(price) > 0) {
          hasPrice = true;
        } else {
          // Check for people-based prices
          for (const [key, value] of formData.entries()) {
            if (
              key.startsWith(`intervals[${index}][prices]`) &&
              key.includes('[price]') &&
              value &&
              parseFloat(value) > 0
            ) {
              hasPrice = true;
              break;
            }
          }
        }

        // Check if this interval is complete
        // For Tours, we only require startDate (no endDate needed)
        let isComplete;
        if (productType === 'Tour') {
          isComplete = startDate && hasPrice;
        } else {
          isComplete = startDate && endDate && hasPrice;
        }

        if (isComplete) {
          hasCompleteInterval = true;
        } else {
          const missingDateMessage =
            productType === 'Tour' ? !startDate : !startDate || !endDate;

          incompleteIntervals.push({
            index: parseInt(index) + 1,
            missingDate: missingDateMessage,
            missingPrice: !hasPrice,
          });
        }
      });

      // If no intervals or no complete intervals, show error
      if (intervalCount === 0) {
        alert('Please add at least one interval with dates and price.');
        return;
      }

      // If we have any incomplete intervals, show error and prevent submission
      if (incompleteIntervals.length > 0) {
        let errorMessage = 'Please complete all intervals before submitting:\n';
        incompleteIntervals.forEach((interval) => {
          errorMessage += `\n- Interval ${interval.index}: `;
          if (interval.missingDate) {
            if (productType === 'Tour') {
              errorMessage += 'Missing start date. ';
            } else {
              errorMessage += 'Missing date range. ';
            }
          }
          if (interval.missingPrice) errorMessage += 'Missing price. ';
        });
        alert(errorMessage);
        return;
      }

      this.isCreatingRates = true;
      console.log('Starting submission');

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRFToken': getCSRFToken(),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((html) => {
          const rateSetDropdown = document.querySelector('#rate_set_dropdown');
          if (rateSetDropdown) {
            rateSetDropdown.outerHTML = html;
            console.log('Request completed');
          } else {
            console.error('Could not find #rate_set_dropdown element');
          }
          this.isCreatingRates = false;
          this.toggleAddRateModal();
        })
        .catch((error) => {
          console.error('Error:', error);
          alert(
            'An error occurred while submitting the form. Please try again.',
          );
          this.isCreatingRates = false;
        });
    },
    submitForm() {
      const step3Element = document.querySelector('.step3');
      if (validateStep(step3Element, 3)) {
        // Sync Choices.js selections to the original select element
        if (this.choicesInstance) {
          const selectedValues = this.choicesInstance.getValue(true); // Get selected values
          const selectElement = document.getElementById('id_rate_set'); // The original select element

          // Clear current options
          selectElement.options.length = 0;

          // Set new options based on selected values
          selectedValues.forEach((value) => {
            const option = new Option(value.label, value.value, true, true);
            selectElement.add(option);
          });
        }

        // Submit the form
        const form = document.querySelector('.add-product-form');
        form.submit();
        closeAllForms();
        showLoadingSpinner();
      }
    },
  });
}
